import { render, staticRenderFns } from "./PaymentWing.vue?vue&type=template&id=6f4ea369&scoped=true"
import script from "./PaymentWing.vue?vue&type=script&lang=js"
export * from "./PaymentWing.vue?vue&type=script&lang=js"
import style0 from "./PaymentWing.vue?vue&type=style&index=0&id=6f4ea369&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4ea369",
  null
  
)

export default component.exports